function NotFound() {
  return (
    <h1 className='center-message'>
      Not found
    </h1>
  )
}

export default NotFound
